import React, { useCallback, useEffect, useMemo, useState } from "react";
import PageHeading from "../../components/PageHeading";
import styles from "../Home/Home.module.css";
import "./Payroll.css";
import Dropdown from "../../components/inputs/Dropdown";
import { Button, EditButton, SaveButton } from "../../components/btn/Buttons";
import TableNew from "../../components/table/TableWithPagination";
import { useSelector } from "react-redux";
import { BankCodeFinder, DeleteIcon, base_url } from "../../utils/utils";
import { Pagination3 } from "../../components/pagination/pagination";
import PayRunsModal from "../../components/modal/PayRunsModal";
import useLastFourFinancialYears from "../../utils/Hook/financialYearHook";
import { monthData } from "../../utils/data";
import SearchApiHook from "../../CustomHooks/SearchApiHook";
import PageLoading from "../../components/PageLoading";
import store from "../../redux/store";
import { get_pay_run_list } from "./payrollSlice";
import { get_bank_master_list } from "../MasterData/masterdataSlice";
import { toast } from "react-toastify";
import SmallModal from "../../components/modal/SmallModal";
import { getOptionLabel, getPaymentMode } from "../../utils/OtherFuncs.js";
import usePaginationState from "../../CustomHooks/usePaginationState.js";
import {
  setLoadingMain,
  setMessAlert,
  setOpenAlert,
} from "../../redux/slice/actionSlice.js";
const PayRuns = () => {
  const {
    entries,
    setEntries,
    pageNo,
    setPageNo,
    searchInput,
    setSearchInput,
    totalCount,
    setTotalCount,
    searchCount,
    setSearchCount,
    prevSearch,
    setPrevSearch,
  } = usePaginationState();

  const [modalData, setModalData] = useState([]);
  const [addData, setAddData] = useState([]);
  const [EditItem, setEditItem] = useState({});
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [action, setAction] = useState(1);

  const [isOpen, setIsOpen] = useState(false);
  const [showData, setShowData] = useState(false);
  // const [loading, setLoading] = useState(false);
  const [open1, setOpen1] = useState(false);
  // const [open, setOpen] = useState(false);
  // const [mess, setMess] = useState("");
  const { bank_master_list } = useSelector((state) => state.masterdata);
  const { pay_run_list, pay_run_loading } = useSelector(
    (state) => state.payroll
  );
  console.log("modalData ===>", modalData);

  const { user_id } = useSelector((state) => state.other);

  useEffect(() => {
    store.dispatch(get_bank_master_list());
  }, []);

  const ChangeAction = (act) => {
    if (act != action) {
      setAction(act);
      setShowData(false);
      setPageNo(1);
      setEntries(5);
      setSearchInput("");
    }
  };

  const apiData = {
    body: {
      action:
        action == 1
          ? "payrunStaffMainData"
          : action == 2
          ? "showGeneratedSalarySheet"
          : "",
      agencyid: user_id,
      month: Number(month),
      year: parseInt(year),
      page: pageNo,
      limit: entries,
      search: searchInput,
    },
    data: {
      setTotalCount: setTotalCount,
      setSearchCount: setSearchCount,
    },
  };

  const options = useLastFourFinancialYears(8);

  // const fetchData = () => {
  //   if (!showData) {
  //     fetchList();
  //   }
  // };

  const fetchList = () => {
    const error = [];
    if (!month) {
      error.push("Please select a month");
    }
    if (!year) {
      error.push("Please select a year");
    }
    const currentDate = new Date();
    const selectedDate = new Date(year, month - 1);
    if (month && year && selectedDate > currentDate) {
      error.push("Future month or year is not allowed");
    }
    if (error.length === 0) {
      store.dispatch(get_pay_run_list(apiData));
      setShowData(true);
    } else if (showData) {
      store.dispatch(setOpenAlert(true));
      store.dispatch(setMessAlert(error));
    }
  };

  const bankCode = useMemo(() => {
    return (data) => BankCodeFinder(data);
  }, [bank_master_list]);

  SearchApiHook(() => fetchList(), searchInput?.trim(), prevSearch, [
    entries,
    pageNo,
  ]);

  const update_bank_details = async (list_id, data1) => {
    const filterData = data1
      ? data1
      : addData?.find((v, i) => v?.id == list_id);
    const filterDataMain = pay_run_list?.find((v, i) => v?.ID == list_id);
    const error = [];
    if (!filterData?.payment_mode) {
      error.push("Please Select Payment Mode");
    }
    if (
      !filterData?.bank_id &&
      filterData?.payment_mode &&
      filterData?.payment_mode != 1
    ) {
      error.push("Please Select Bank Account");
    }
    if (error?.length == 0) {
      store.dispatch(setLoadingMain(true));
      try {
        const body = {
          action: "processStaffMonthlySalaryData",
          empid: list_id,
          agencyid: user_id,
          id: filterDataMain?.salary_id,
          mop: filterData?.payment_mode,
          bankid: filterData?.bank_id || 0,
        };
        const response = await fetch(`${base_url}payroll/payrun.php`, {
          method: "POST",
          body: JSON.stringify(body),
        });
        const res = await response.json();
        if (res.success) {
          toast.success(res.message);
          if (data1) {
            setEditItem({});
            setOpen1(false);
          } else {
            const filterDataNot = addData?.filter((v, i) => v?.id != list_id);
            setAddData(filterDataNot);
          }
          // store.dispatch(get_pay_run_list(apiData));
          fetchList();
        } else {
          toast.error(res.message);
        }
      } catch (error) {
        console.log("error ===>", error);
      } finally {
        store.dispatch(setLoadingMain(false));
      }
    } else {
      store.dispatch(setOpenAlert(true));
      store.dispatch(setMessAlert(error));
    }
  };

  const getModeOfPayment = useCallback(
    (payment_mode) => getPaymentMode(payment_mode),
    [pay_run_list]
  );

  const getPaymentStatus = useCallback(
    (payment_status) => {
      switch (payment_status) {
        case 0:
          return "Pending";
        case 1:
          return "Processing";
        case 2:
          return "Paid";
        default:
          return "";
      }
    },
    [pay_run_list]
  );

  const getRoleOption = useCallback(
    (role) => getOptionLabel(role),
    [pay_run_list]
  );

  const pay_update = async () => {
    try {
      store.dispatch(setLoadingMain(true));
      const body = {
        action: "pay",
        month: month,
        year: year,
        agencyid: user_id,
        salaryIds: pay_run_list?.map((v, i) => v?.salary_id),
      };
      const response = await fetch(`${base_url}payroll/payrun.php`, {
        method: "POST",
        body: JSON.stringify(body),
      });
      const res = await response.json();
      if (res.success) {
        toast.success(res.message);
        setPageNo(1);
        setEntries(5);
        // store.dispatch(get_pay_run_list(apiData));
        fetchList();
      } else if (!res.success) {
        store.dispatch(setOpenAlert(true));
        store.dispatch(setMessAlert(res.message));
      }
    } catch (error) {
      console.log("error ===", error);
    } finally {
      store.dispatch(setLoadingMain(false));
    }
  };

  return (
    <div className="container">
      <PageHeading
        title={"Pay Runs"}
        right={
          <div className="df gap10">
            <Button
              title={"Run payroll"}
              bgColor={action == 1 ? "#2196f3" : "#808080"}
              onClick={() => ChangeAction(1)}
            />
            <Button
              title={"Generate salary sheet"}
              bgColor={action == 2 ? "#2196f3" : "#808080"}
              onClick={() => ChangeAction(2)}
            />
          </div>
        }
      />

      {!showData || (showData && pay_run_list?.length == 0) ? (
        <div className="tb1">
          {action == 1 && <p>Process Pay Run for : </p>}
          <div className="MonYear">
            <p style={{ fontSize: "16px" }}>MONTH :</p>
            <div className="DR">
              <Dropdown
                value={month}
                onChange={(e) => setMonth(e.target.value)}
                options={
                  <>
                    <option value={""}>SELECT</option>
                    {monthData.map((v, i) => (
                      <option key={v?.id} value={v?.id}>
                        {v?.label}
                      </option>
                    ))}
                  </>
                }
              />
            </div>
            <p style={{ fontSize: "16px" }}>YEAR :</p>
            <div className="DR">
              <Dropdown
                value={year}
                onChange={(e) => setYear(e.target.value)}
                options={
                  <>
                    <option value={""}>SELECT</option>
                    {options}
                  </>
                }
              />
            </div>
            <Button
              title="SUBMIT"
              onClick={() => {
                fetchList();
              }}
            />
          </div>
        </div>
      ) : (
        <></>
      )}

      {showData && (
        <>
          <div style={{ margin: "20px 0" }}>
            <div className={styles.desc}>
              {action == 1 ? " PayRuns of month" : "Generate salary of month :"}{" "}
              {monthData?.find((v, i) => v?.id == month)?.label} - {year}
            </div>
            {action == 2 && pay_run_list?.length > 0 && (
              <div
                className={styles.desc}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "1rem",
                  marginTop: "1rem",
                }}
              >
                Click here to pay salary :{" "}
                <Button
                  bgColor={"rgb(33, 150, 243)"}
                  onClick={pay_update}
                  title={"Pay"}
                />
              </div>
            )}
          </div>
          <Pagination3
            totalCount={totalCount > searchCount ? searchCount : totalCount}
            SerchInput={searchInput}
            serchChange={(e) => {
              setSearchInput(e.target.value);
              setPrevSearch(searchInput);
              setPageNo(1);
            }}
            pageNo={pageNo}
            setPageNo={setPageNo}
            entries={entries}
            setEntries={setEntries}
          >
            {pay_run_loading ? (
              <PageLoading />
            ) : (
              <TableNew
                mt={5}
                nodata={
                  pay_run_list?.length == 0 && !pay_run_loading ? true : false
                }
                headData={
                  action == 1
                    ? [
                        "EMPLOYEE CODE",
                        "EMPLOYEE NAME",
                        "PAID DAYS",
                        "GROSS PAY",
                        "NET PAY",
                        "PAYMENT MODE",
                        "BANK",
                        "PAYMENT STATUS",
                        "ACTION",
                      ]
                    : action == 2
                    ? [
                        "EMPLOYEE CODE",
                        "EMPLOYEE NAME",
                        "ROLE",
                        "MODE OF PAYMENT",
                        "BANK",
                        "NET PAY",
                      ]
                    : ""
                }
                body={
                  <>
                    {pay_run_list?.length != 0 &&
                      pay_run_list?.map((item, i) => (
                        <>
                          {action == 1 ? (
                            <tr key={i}>
                              <td
                                className="bank_master_hover"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  console.log("item ===>", item);

                                  if (item?.ROLE != 0 && !item?.BASIC_PAY) {
                                    store.dispatch(setOpenAlert(true));
                                    store.dispatch(
                                      setMessAlert(
                                        "Please fill staff salary details in Payroll / Staff Master first."
                                      )
                                    );
                                  } else if (
                                    item?.ROLE == 0 &&
                                    item?.STAFF_TYPE == null
                                  ) {
                                    store.dispatch(setOpenAlert(true));
                                    store.dispatch(
                                      setMessAlert(
                                        "Please fill staff salary and commission details in Payroll / Staff Master first."
                                      )
                                    );
                                  } else if (
                                    item?.ROLE === 0 &&
                                    // item?.STAFF_TYPE == 1
                                    (item?.payment_status < 1
                                      ? item?.STAFF_TYPE == 1
                                      : item?.salary_type == 1) &&
                                    item?.commission_products?.reduce(
                                      (sum, prod) =>
                                        sum + Number(prod.QUANTITY || 0),
                                      0
                                    ) === 0
                                  ) {
                                    store.dispatch(setOpenAlert(true));
                                    store.dispatch(
                                      setMessAlert(
                                        "This month, this delivery person has not delivered any cylinders."
                                      )
                                    );
                                  } else {
                                    setModalData({ ...item });
                                    setIsOpen(true);
                                  }
                                }}
                              >
                                {item.EMP_CODE}
                              </td>
                              <td>{item.EMP_NAME}</td>
                              <td>{item.actual_payable_days}</td>
                              <td>{item.gross_pay}</td>
                              <td>{item.net_pay}</td>
                              {item.gross_pay ? (
                                <>
                                  <td>
                                    {item.payment_mode ? (
                                      <>
                                        {getModeOfPayment(item?.payment_mode)}
                                      </>
                                    ) : (
                                      <Dropdown
                                        width2=""
                                        value={
                                          addData?.find(
                                            (data) => data.id === item.ID
                                          )?.payment_mode || ""
                                        }
                                        onChange={(e) => {
                                          setAddData((prevData) => {
                                            const existingItem = prevData.find(
                                              (data) => data.id === item.ID
                                            );

                                            if (existingItem) {
                                              // If ID exists, update payment_mode
                                              return prevData.map((data) =>
                                                data.id === item.ID
                                                  ? {
                                                      ...data,
                                                      payment_mode:
                                                        e.target.value,
                                                    }
                                                  : data
                                              );
                                            } else {
                                              // If ID doesn't exist, create new entry with id and payment_mode
                                              return [
                                                ...prevData,
                                                {
                                                  id: item.ID,
                                                  payment_mode: e.target.value,
                                                },
                                              ];
                                            }
                                          });
                                        }}
                                        options={
                                          <>
                                            <option value="">SELECT</option>
                                            <option value="1">CASH</option>
                                            <option value="2">CHEQUE</option>
                                            <option value="3">ONLINE</option>
                                          </>
                                        }
                                      />
                                    )}
                                  </td>

                                  <td>
                                    {item.bank_id || item?.payment_mode == 1 ? (
                                      item?.bank_name || "-"
                                    ) : (
                                      <Dropdown
                                        width2=""
                                        disabled={
                                          addData?.find(
                                            (data) => data.id === item.ID
                                          )?.payment_mode == "1"
                                        }
                                        value={
                                          addData?.find(
                                            (data) => data.id === item.ID
                                          )?.bank_id || ""
                                        }
                                        onChange={(e) => {
                                          setAddData((prevData) => {
                                            const existingItem = prevData.find(
                                              (data) => data.id === item.ID
                                            );

                                            if (existingItem) {
                                              // If ID exists, update bank_id
                                              return prevData.map((data) =>
                                                data.id === item.ID
                                                  ? {
                                                      ...data,
                                                      bank_id: e.target.value,
                                                    }
                                                  : data
                                              );
                                            } else {
                                              // If ID doesn't exist, create new entry with id and bank_id
                                              return [
                                                ...prevData,
                                                {
                                                  id: item.ID,
                                                  bank_id: e.target.value,
                                                },
                                              ];
                                            }
                                          });
                                        }}
                                        options={
                                          <>
                                            <option value={""}>SELECT</option>
                                            {bank_master_list
                                              ?.filter(
                                                (v) =>
                                                  v?.BANK_CODE ==
                                                    "OVER DRAFT" ||
                                                  v?.BANK_CODE == "LOAN" ||
                                                  v?.BANK_CODE == "SAVINGS" ||
                                                  v?.BANK_CODE == "CURRENT"
                                              )
                                              ?.map((v, i) => (
                                                <option key={i} value={v?.ID}>
                                                  {bankCode(v)}
                                                </option>
                                              ))}
                                          </>
                                        }
                                      />
                                    )}
                                  </td>

                                  {/* <td>{item.payment_status}</td> */}
                                  <td>
                                    {getPaymentStatus(item?.payment_status)}
                                  </td>
                                </>
                              ) : (
                                <>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                </>
                              )}

                              <td
                                style={{
                                  display: "flex",
                                  gap: "15px",
                                  justifyContent: "center",
                                }}
                              >
                                {item?.salary_sr_no && (
                                  <>
                                    {item.payment_status == 1 && (
                                      <EditButton
                                        onClick={() => {
                                          setEditItem(item);
                                          setOpen1(true);
                                        }}
                                      />
                                    )}
                                    {item.payment_status == 0 && (
                                      <SaveButton
                                        onClick={() =>
                                          update_bank_details(item?.ID)
                                        }
                                      />
                                    )}
                                  </>
                                )}
                              </td>
                            </tr>
                          ) : (
                            <tr key={i}>
                              <td>{item.emp_code}</td>
                              <td>{item.emp_name}</td>
                              <td>{getRoleOption(item?.role)}</td>
                              <td>{getModeOfPayment(item?.payment_mode)}</td>
                              <td>{item.bank_name}</td>
                              <td>{item.net_pay}</td>
                            </tr>
                          )}
                        </>
                      ))}
                  </>
                }
              />
            )}
          </Pagination3>
        </>
      )}

      {open1 && (
        <SmallModal
          minW={"340px"}
          title={"Edit Details"}
          // style={{
          //   minWidth: "350px",
          // }}
          isOpen={open1}
          okBtnText={"SAVE"}
          setIsOpen={setOpen1}
          ok_btn_click={() => {
            update_bank_details(EditItem?.ID, EditItem);
          }}
          mess={
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "1rem",
                textAlign: "left",
              }}
            >
              <Dropdown
                width2=""
                label="Payment Mode"
                value={EditItem?.payment_mode}
                onChange={(e) => {
                  const value = e.target.value;
                  setEditItem({
                    ...EditItem,
                    payment_mode: value,
                    bank_id: value == 1 ? "" : EditItem?.bank_id,
                  });
                }}
                options={
                  <>
                    <option value="">SELECT</option>
                    <option value="1">CASH</option>
                    <option value="2">CHEQUE</option>
                    <option value="3">ONLINE</option>
                  </>
                }
              />
              <Dropdown
                width2=""
                disabled={EditItem?.payment_mode == 1}
                label="Bank Account"
                value={EditItem?.bank_id}
                onChange={(e) => {
                  const value = e.target.value;
                  setEditItem({ ...EditItem, bank_id: value });
                }}
                options={
                  <>
                    <option value={""}>SELECT</option>
                    {bank_master_list
                      ?.filter(
                        (v) =>
                          v?.BANK_CODE == "OVER DRAFT" ||
                          v?.BANK_CODE == "LOAN" ||
                          v?.BANK_CODE == "SAVINGS" ||
                          v?.BANK_CODE == "CURRENT"
                      )
                      ?.map((v, i) => (
                        <option key={i} value={v?.ID}>
                          {bankCode(v)}
                        </option>
                      ))}
                  </>
                }
              />
            </div>
          }
          okbtn={true}
        />
      )}

      {isOpen && (
        <PayRunsModal
          setIsOpen={setIsOpen}
          modalData={modalData}
          CommissionType={
            modalData?.ROLE == 0 &&
            // modalData?.STAFF_TYPE == 1
            (modalData?.payment_status < 1
              ? modalData?.STAFF_TYPE == 1
              : modalData?.salary_type == 1)
          }
          payable_days={
            month == 2
              ? new Date(year, 1, 29).getDate() === 29
                ? 29
                : 28
              : monthData?.find((v) => v?.id == month)?.payable_days
          }
          month={month}
          year={year}
          fetchData={() => fetchList()}
        />
      )}
    </div>
  );
};

export default PayRuns;
